angular.module('app.shared.leaguesService', [])
  .factory('app.shared.leaguesService', [
    '$http',
    '$httpParamSerializerJQLike',
    'hostnameMatchService',
    function ($http, $httpParamSerializerJQLike, hostnameMatchService) {
      return {
        getList: function (platform, includes, only) {

          let query = {};

          query.platform = platform ? platform : window.location.platform(undefined, hostnameMatchService.hostname());

          if (includes) {
            query.includes = includes;
          }

          if (only) {
            query.only = only;
          }

          query = $httpParamSerializerJQLike(query);
          return $http.get(window.location.api('leagues?' + query));
        },
        getLeague: function (league_id) {
          return $http.get(window.location.api('leagues/' + league_id));
        },
        getTeams: function (league_id) {
          return $http.get(window.location.api('leagues/' + league_id + '/teams'));
        },
        getListByAccess: () => {
          return $http.get(window.location.api('leagues/by_access'));
        },
        getTeamsByAccess: (league_id) => {
          return $http.get(window.location.api(`leagues/${league_id}/teams/by_access`));
        }
      };
    }
  ]);


// WEBPACK FOOTER //
// ./app.v2/components/shared/leaguesService.js